import React from "react"

import { connect } from 'react-redux';

import {Link, } from 'react-router-dom';
import {
    Card, CardBlock, CardTitle,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,
    ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
    Input,
    Badge,
    Row,Modal, ModalHeader, ModalBody, ModalFooter,
    Nav, NavItem, NavLink,Dropdown, Col, TabPane , TabContent
} from 'reactstrap';

import classnames from 'classnames';

import ModalTablas from '../../components/catalogos/modal_tablas';
import ModalPlazos from '../../components/plazosvencimientos/modal';
import ModalParametros from '../../components/parametrossistema/modal';
import ModalDatosFactura from '../../components/datosfactura/modal';
// styling
import './style.css';

const catalogos =[
         'Bancos',
         'Metodos de Pago',
         'Formas de Pago',
         'Codigos Postales',
         'Monedas',
         'Paises',
         'Impuestos',
         'Regimen Fiscal',
         'Usos de CFDI',
         'Tasas o Cuotas',
         'Unidades',
         'Relaciones',
         'Productos y Servicios',
         'Aduanas',
    ];

class Menu extends React.Component{

	constructor(props){
		super(props);


    this.state = {
      menu: 0,
      submenu:0,
      modal:false,
      titulo:'error',
      catalogo:0,
      modal_plazos:false,
      modal_parametros:false,
      modal_datos_facutra:false,
    };

     this.toggle = this.toggle.bind(this);
     this.toggle_modal = this.toggle_modal.bind(this);
     this.toggle_plazos = this.toggle_plazos.bind(this);
     this.toggle_parametros = this.toggle_parametros.bind(this);
     this.toggle_datos_factura = this.toggle_datos_factura.bind(this);
  }
  nada(){}
    toggle_modal(index=0){	

		this.setState({
			modal : !this.state.modal,
			menu: 0,
            submenu:0,
            titulo:catalogos[index],
            catalogo:index,			
		})
	}
	toggle_plazos(){	

		this.setState({
			modal_plazos : !this.state.modal_plazos,
			menu: 0,
            submenu:0,		
		})
	}
	toggle_parametros(){	

		this.setState({
			modal_parametros : !this.state.modal_parametros,
			menu: 0,
            submenu:0,		
		})
	}
	toggle_datos_factura(){	

		this.setState({
			modal_datos_facutra : !this.state.modal_datos_facutra,
			menu: 0,
            submenu:0,		
		})
	}

  	toggle(menu,id) {
	  	let valor=0;

		if(menu===1){
			if(parseInt(this.state.menu)!==id)
	  		valor=id;
		    this.setState({
		      menu: valor
		    });
		}else if(menu===2){
			if(parseInt(this.state.submenu)!==id)
	  		valor=id;
		    this.setState({
		      submenu: valor
		    });

		}else if(menu ===4){
			if(parseInt(this.state.submenu)!==id)
	  		valor=id;
		    this.setState({
		      submenu: valor
		    });
		}
	}
  	
  	toggleNavTab(tab) {
	    if (this.state.activeTab !== tab) {
	    	this.setState({
	    		activeTab: tab
	    	});
		}
	}

  
	render(){
		return(

			<div className='pl-4 letras_menu' style={{	backgroundColor: '#e2e2e2'}}>
				<Nav className='pl-4' >
		          <NavItem>
		           <Dropdown  nav isOpen={parseInt(this.state.menu)===1?true:false} toggle={() => {this.toggle(1,1);}} >
		            <DropdownToggle className='letras_menu'  nav caret>
		              Catalogos
		            </DropdownToggle>
		            <DropdownMenu> 	          
		              	<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/proveedores');}} >Provedores</DropdownItem>
						<DropdownItem onClick={() => { this.props.props.history.push('/clientes')}}> Clientes </DropdownItem>
						<DropdownItem onClick={() => { this.props.props.history.push('/inventario')}}> Productos </DropdownItem>
		            </DropdownMenu>
		          </Dropdown>		           
		          </NavItem>
		          <NavItem>
		            <Dropdown nav isOpen={parseInt(this.state.menu)===2?true:false} toggle={() => {this.toggle(1,2);}} >
		            <DropdownToggle nav caret>
		             Movimientos
		            </DropdownToggle>
					<DropdownMenu className='letras_menu'>
						<DropdownItem onClick={() => { this.props.props.history.push('/invoiceModule');}} >Facturación</DropdownItem>
					    <DropdownItem onClick={() => { this.props.props.history.push('/facturacion/C-A/Clientes');}} >C / A de Clientes</DropdownItem>
						<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/movimientoscompras');}} >Compras</DropdownItem>
						<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/C-A/Proveedores');}} >C / A de Proveedores</DropdownItem>
						<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/movimientosAlmacenes');}} >Almacen</DropdownItem>
						<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/inventarioFisico');}} >Inventario Fisico</DropdownItem>
					</DropdownMenu>
		          </Dropdown>	
		          </NavItem>
		          <NavItem>
		           <Dropdown nav isOpen={parseInt(this.state.menu)===6?true:false} toggle={() => {this.toggle(1,6);}} >
		            <DropdownToggle nav caret>
		             Parametros
		            </DropdownToggle>
					<DropdownMenu className='letras_menu'>
						<Dropdown className='ajuste_menu' nav direction="right"   isOpen={parseInt(this.state.submenu)===3?true:false} toggle={() => {this.toggle(2,3);}}  >
							<DropdownToggle  nav caret>Catalogos</DropdownToggle>
							<DropdownMenu  className='letras_menu' style={{	float: 'right', position: 'fixed',  top: '0' , left: '100%'}}> 	
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/folios');}}>Folios de Documentos</DropdownItem>
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/embarques');}}>Vias de Embarque</DropdownItem>
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/lab');}}>Conceptos LAB</DropdownItem>
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/impuestos');}}>Impuestos</DropdownItem>
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/descuentos');}}>Descuentos</DropdownItem>
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/almacenes');}}>Alamcenes</DropdownItem>
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/lineas');}}>Lineas</DropdownItem>
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/marcas');}}>Marcas</DropdownItem>
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/estilos');}}>Estilos</DropdownItem>
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/coloressabores');}}>Colores/Sabores</DropdownItem>
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/medidas');}}>Medidas</DropdownItem>
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/tipos_movimientos');}}>Tipo de Movimientos</DropdownItem>
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/tipos_conceptos');}}>Tipos de Conceptos</DropdownItem>
								<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/terminos_pago');}}>Terminos de Pago</DropdownItem>
							</DropdownMenu>
						</Dropdown>
						<DropdownItem onClick={() => {this.toggle_datos_factura();}}>Datos Factura E.</DropdownItem>
						<DropdownItem onClick={() => {this.toggle_parametros();}}>Parametros Especiales</DropdownItem>
						<DropdownItem onClick={() => { this.props.props.history.push('/facturacion/tipos_cambio');}}>Tipos de Cambios</DropdownItem>
						<DropdownItem onClick={() => {this.toggle_plazos();}}>Plazos Vencimientos</DropdownItem>
						
						<Dropdown className='letras_menu ajuste_menu' nav direction="right"   isOpen={parseInt(this.state.submenu)===4?true:false} toggle={() => {this.toggle(2,4);}}  >
				            <DropdownToggle  nav caret>
				              CFDI 3.3
				            </DropdownToggle>
				            <DropdownMenu className='letras_menu' style={{	float: 'right', position: 'fixed',  top: '0' , left: '100%'}}> 	

				                <DropdownItem onClick={() => {this.toggle_modal(0);}}>Bancos</DropdownItem>
							    <DropdownItem onClick={() => {this.toggle_modal(1);}}>Metodos de Pago</DropdownItem>
							    <DropdownItem onClick={() => {this.toggle_modal(2);}}>Formas de Pago</DropdownItem>
								<DropdownItem onClick={() => {this.toggle_modal(3);}}>Codigos Postales</DropdownItem>
								<DropdownItem onClick={() => {this.toggle_modal(4);}}>Monedas</DropdownItem>
								<DropdownItem onClick={() => {this.toggle_modal(5);}}>Paises</DropdownItem>
								<DropdownItem onClick={() => {this.toggle_modal(6);}}>Impuestos</DropdownItem>
								<DropdownItem onClick={() => {this.toggle_modal(7);}}>Regimen Fiscal</DropdownItem>
								<DropdownItem onClick={() => {this.toggle_modal(8);}}>Usos de CFDI</DropdownItem>
								<DropdownItem onClick={() => {this.toggle_modal(9);}}>Tasas o Cuotas</DropdownItem>
								<DropdownItem onClick={() => {this.toggle_modal(10);}}>Unidades</DropdownItem>
								<DropdownItem onClick={() => {this.toggle_modal(11);}}>Relaciones</DropdownItem>
								<DropdownItem onClick={() => {this.toggle_modal(12);}}>Productos y Servicios</DropdownItem>
								<DropdownItem onClick={() => {this.toggle_modal(13);}}>Aduanas</DropdownItem>
				            </DropdownMenu>
				          </Dropdown>
						
					</DropdownMenu>
		          </Dropdown>		           
		          </NavItem>
		        </Nav>
		        <ModalTablas
					open={this.state.modal}
					toggle={this.toggle_modal}					
					titulo={this.state.titulo}
					catalogo={this.state.catalogo}
					retorno={this.nada}
				/>
				<ModalPlazos
					open={this.state.modal_plazos}
					toggle={this.toggle_plazos}					
				/>
				{this.state.modal_parametros&&
				<ModalParametros
					open={this.state.modal_parametros}
					toggle={this.toggle_parametros}					
				/>
			    }
			    {this.state.modal_datos_facutra&&
				<ModalDatosFactura
					open={this.state.modal_datos_facutra}
					toggle={this.toggle_datos_factura}					
				/>
			    }
				
			</div>

			)
	}

}


export default Menu;


// WEBPACK FOOTER //
// ./src/views/facturacion/menu.js